import { OverlayContainer } from '@angular/cdk/overlay';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatRadioChange } from '@angular/material';
import { CurrentApiService, CurrentService, fullApiPath } from 'dbweb-core';
import { Subscription } from 'rxjs';
import { MainNavService } from '../services/main-nav.service';
import { ThemeService, ThemeModel, ThemeColor } from '../services/theme.service';
import {
	PortraitEditComponent,
	PortraitEditComponentData,
	PortraitEditComponentResultData
} from './portrait-edit/portrait-edit.component';
import { portraitDefault } from '../const';
@Component({
	selector: 'common-userinfo',
	templateUrl: './userinfo.component.html',
	styleUrls: ['./userinfo.component.scss']
})
export class UserinfoComponent implements OnInit, OnDestroy {
	@HostBinding('class.user-info') hostClass = true;
	@ViewChild('portraitImage', { static: false }) portraitImage: ElementRef<HTMLImageElement>;
	uploadURL: string;
	num = 0;
	isEditNickName = false;
	nickName = '';
	themeColor: ThemeColor;
	themeModel: ThemeModel;
	mainNavStyle: 'full' | 'min';
	portraitURL: string;
	private subject: Subscription[] = [];
	constructor(
		public overlayContainer: OverlayContainer,
		public curr: CurrentService,
		private httpClient: HttpClient,
		private api: CurrentApiService,
		private theme: ThemeService,
		public dialog: MatDialog,
		public mainNav: MainNavService
	) {
		this.subject.push(
			this.mainNav.navMin.subscribe(v => {
				if (v) {
					this.mainNavStyle = 'min';
				} else {
					this.mainNavStyle = 'full';
				}
			}),
			this.curr.change$.subscribe(v => {
				if (v && v.HeadPortrait) {
					this.portraitURL = v.portraitURL;
				} else {
					this.portraitURL = portraitDefault;
				}
			})
		);
	}
	ngOnDestroy() {
		this.subject.forEach(v => v.unsubscribe());
	}

	ngOnInit() {
		this.subject.push(
			this.theme.theme.subscribe(v => {
				this.themeColor = v.color;
				this.themeModel = v.model;
			}),
			this.api.get<string>('get-user-portrait-url').subscribe(u => {
				this.uploadURL = fullApiPath(u);
			})
		);
	}
	setTheme() {
		this.theme.setTheme(this.themeColor + '-' + this.themeModel + '-theme');
	}

	postFile(fileToUpload: File) {
		const formData: FormData = new FormData();
		formData.append('portrait', fileToUpload, fileToUpload.name);
		return this.httpClient.post(this.uploadURL, formData, { withCredentials: true }).subscribe(
			() => {
				this.curr.setPortrait(true);
				this.num++;
			},
			(error: HttpErrorResponse) => {
				console.log(error);
			}
		);
	}
	editNickName() {
		this.nickName = this.curr.data.NickName;
		this.isEditNickName = true;
	}
	editDone() {
		this.api.post<boolean>('change-user-nickname', this.nickName).subscribe(() => {
			this.curr.setNickName(this.nickName);
			this.isEditNickName = false;
		});
	}
	showPortraitEdit() {
		const dialogRef = this.dialog.open(PortraitEditComponent, {
			width: '480px',
			data: {
				img: this.portraitImage.nativeElement,
				default: this.portraitURL === portraitDefault
			} as PortraitEditComponentData
		});

		dialogRef.afterClosed().subscribe((result: PortraitEditComponentResultData) => {
			if (result && result.ok) {
				if (result.data) {
					this.postFile(dataURLtoFile(result.data, 'portrait.jpg'));
				} else {
					this.api.post<boolean>('clear-user-portrait').subscribe(() => {
						this.curr.setPortrait(false);
					});
				}
			}
		});
	}
	navStyleChange(event: MatRadioChange) {
		this.mainNav.setNavMin(event.value === 'min');
	}
}
function dataURLtoFile(dataurl: string, filename: string): File {
	const arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new File([u8arr], filename, { type: mime });
}
